module.exports = __webpack_public_path__ + "static/img/logoNew.6bec5bbc.svg";